var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeTrendUp = function SvgHomeTrendUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#131214",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.027 3.787-7.187 5.6c-1.2.933-2.173 2.92-2.173 4.426v9.88c0 3.094 2.52 5.627 5.613 5.627h15.44c3.094 0 5.614-2.533 5.614-5.613V14c0-1.613-1.08-3.68-2.4-4.6l-8.24-5.773c-1.867-1.307-4.867-1.24-6.667.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 15.333-5.6 5.6-2.133-3.2L10 22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.333 15.334H22V18"
  }))));
};
export { SvgHomeTrendUp as ReactComponent };
export default __webpack_public_path__ + "5d2598c7855bc441d5eb11998582b73d.svg";